import UdfCustomField from "./UdfCustomField";
import { UDF_FILTER_FIELD_COMPONENTS } from "./udfFilteringFields";

// Helper to get field type from customFieldsData
const getFieldType = (fieldSlug, customFieldsData) => {
  const dataArray = customFieldsData?.results || customFieldsData || [];
  if (!Array.isArray(dataArray)) return "text";

  const field = dataArray.find((f) => f.slug === fieldSlug);
  return field?.type || "text";
};

// Value adapter for filter format
const createFilterValueAdapter = (customFieldsData) => {
  return {
    // Convert filter array to object format
    // For range fields: [{ field: "udf_1", type: "integer", values: [{min_value: 1, max_value: 10}, ...] }]
    // For date: [{ field: "udf_1", type: "date", values: [{start: "...", end: "..."}, ...] }]
    // For other fields: [{ field: "udf_1", type: "text", values: ["val1", "val2"] }]
    // Object format: { "udf_1": [{ min_value: 1, max_value: 10 }, ...] } or { "udf_1": ["val1", "val2"] }
    toInternal: (filterArray) => {
      if (!Array.isArray(filterArray)) return {};
      return filterArray.reduce((acc, filter) => {
        acc[filter.field] = filter.values || [];
        return acc;
      }, {});
    },

    // Convert object format back to filter array
    fromInternal: (objectValue) => {
      if (!objectValue || Object.keys(objectValue).length === 0) return [];

      return Object.entries(objectValue).map(([fieldSlug, values]) => {
        const fieldType = getFieldType(fieldSlug, customFieldsData);

        return {
          field: fieldSlug,
          type: fieldType,
          values: Array.isArray(values) ? values : [values],
        };
      });
    },
  };
};

function UdfCustomFieldFilter({
  customFieldsData,
  value = [],
  onChange,
  placeholder = "Add filter",
  isLoading = false,
}) {
  return (
    <UdfCustomField
      customFieldsData={customFieldsData}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      isLoading={isLoading}
      disabled={false}
      fieldComponents={UDF_FILTER_FIELD_COMPONENTS}
      allowMultipleValuesForAllFields
      valueAdapter={createFilterValueAdapter(customFieldsData)}
    />
  );
}

export default UdfCustomFieldFilter;
